import type React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/cnUtils';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import type { ImportRow } from '../../importRows';
import { IMPORT_CARD_FIGURES } from './importCardsMeta';

type ImportCardFiguresProps = {
    row: ImportRow;
};

/**
 * A card's quantity, cost and sale price on one line, each behind its label
 * in the muted colour ("Qty 1 · Cost ₾ 2,100.00 · Sale price ₾ 2,499.00"),
 * wrapping when a language's labels are long. Muted on an excluded row.
 */
export const ImportCardFigures: React.FC<ImportCardFiguresProps> = ({
    row,
}) => {
    const { t } = useTranslation('pages');

    return (
        <div
            className={cn(
                'flex flex-wrap gap-x-3 gap-y-0.5 text-sm tabular-nums',
                row.isExcluded && 'text-muted',
            )}
        >
            {IMPORT_CARD_FIGURES.map(({ testId, labelKey, valueOf }) => (
                <span
                    key={testId}
                    {...getNodeTestIdProp(
                        `catalog-import-row-${testId}-${row.rowNumber}`,
                    )}
                >
                    <span className="text-muted">{t(labelKey)}</span>{' '}
                    {valueOf(row)}
                </span>
            ))}
        </div>
    );
};
